{
  "nav": {
    "tauler": "Centro de control",
    "activacions": "Activaciones",
    "seguiment": "Seguimiento en directo",
    "novaActivacio": "Nueva activación"
  },
  "titols": {
    "tauler": "Centro de control",
    "activacions": "Activaciones",
    "detall": "Detalle de la activación",
    "seguiment": "Seguimiento en directo",
    "novaActivacio": "Nueva activación"
  },
  "confirmacions": "{{confirmats}}/{{total}}",
  "columnes": {
    "activacio": "Activación",
    "codi": "Código",
    "tipus": "Tipo",
    "titol": "Título",
    "area": "Área",
    "servei": "Servicio",
    "zona": "Zona",
    "tecnic": "Técnico de guardia",
    "usuaris": "Usuarios a informar",
    "confirmacions": "Confirmaciones",
    "estat": "Estado",
    "obert": "Abierta"
  },
  "tauler": {
    "kpi": {
      "obertes": "Abiertas",
      "obertesDetall": "{{it}} Guardia · {{crisi}} Crisis",
      "crisi": "En áreas de crisis",
      "resposta": "Respuesta media",
      "respostaDetall": "Hasta la primera confirmación",
      "confirmacions": "Confirmaciones",
      "confirmacionsDetall": "{{confirmats}} de {{total}} destinatarios",
      "guardia": "Áreas con guardia",
      "guardiaDetall_one": "de {{count}} área",
      "guardiaDetall_other": "de {{count}} áreas",
      "tancades": "Cerradas (mes)",
      "tancadesDetall": "Resueltas, mitigadas o finalizadas",
      "crisiDetall_one": "{{count}} área de crisis activa",
      "crisiDetall_other": "{{count}} áreas de crisis activas"
    },
    "obertes": "Activaciones abiertas",
    "veureTotes": "Ver todas",
    "senseObertes": "No hay ninguna activación abierta.",
    "perDia": "Activaciones por día (últimos {{dies}} días)",
    "confirmacionsDirecte": "Confirmaciones en directo",
    "confirmatsDe": "{{confirmats}} de {{total}} destinatarios confirmados",
    "tecnicsArea": "Técnicos de guardia por área",
    "senseTecnic": "Sin técnico de guardia",
    "ambdues": "Guardia y Crisis",
    "senseArees": "No hay áreas con calendario de guardia.",
    "substitut": "sust. {{nom}}"
  },
  "llista": {
    "tipusArea": "Tipo de área",
    "totesArees": "Todas las áreas",
    "periode": "Periodo",
    "periodes": {
      "7": "Últimos 7 días",
      "30": "Últimos 30 días",
      "90": "Últimos 90 días",
      "tots": "Todo el historial"
    },
    "totsTipus": "Todos los tipos",
    "totsServeis": "Todos los servicios",
    "totesZones": "Todas las zonas",
    "totsEstats": "Todos los estados",
    "persona": "Solo las mías",
    "cerca": "Código, título o servicio",
    "buida": "No hay activaciones con estos filtros.",
    "exporta": "Exportar",
    "mostrant_one": "Mostrando {{count}} de {{total}} activaciones",
    "mostrant_other": "Mostrando {{count}} de {{total}} activaciones",
    "pagina": "Página {{page}} de {{total}}",
    "anterior": "Anterior",
    "seguent": "Siguiente",
    "chip": {
      "tots": "Todos",
      "totes": "Todas",
      "tipus": "Tipo: {{valor}}",
      "area": "Área: {{valor}}",
      "servei": "Servicio: {{valor}}",
      "zona": "Zona: {{valor}}",
      "estat": "Estado: {{valor}}",
      "obertes": "Abiertas",
      "obertesN": "Abiertas · {{count}}",
      "meves": "Mías",
      "tancades": "Cerradas",
      "filtres": "Filtros",
      "filtresN": "Filtros · {{count}}"
    },
    "nova": "Nueva",
    "cercaEtiqueta": "Buscar activaciones",
    "filtresRapids": "Filtros rápidos",
    "capTriada": "Ninguna activación seleccionada",
    "capTriadaText": "Elige una de la lista para ver su detalle."
  },
  "detall": {
    "tornaLlista": "Volver a la lista",
    "nivell": "Nivel {{nivell}}",
    "espera": "Espera {{temps}}",
    "versio": "v{{versio}}",
    "panells": {
      "dades": "Datos de la activación",
      "cronologia": "Cronología",
      "conversa": "Conversación",
      "destinataris": "Destinatarios",
      "escalat": "Cadena de escalado",
      "documentacio": "Documentación del servicio"
    },
    "camps": {
      "codi": "ID",
      "tipus": "Tipo",
      "departament": "Departamento",
      "area": "Área",
      "servei": "Servicio",
      "zona": "Zona / ubicación",
      "activador": "Persona activadora",
      "contacte": "Persona de contacto",
      "inici": "Inicio del incidente",
      "obert": "Fecha de apertura",
      "primeraConfirmacio": "Primera confirmación",
      "canals": "Canales",
      "descripcio": "Descripción",
      "proves": "Pruebas realizadas",
      "risc": "Riesgo",
      "perills": "Peligros identificados",
      "mesures": "Medidas de actuación",
      "itcau": "Incidencia ITCAU",
      "motiuTancament": "Motivo de cierre",
      "tancada": "Fecha de cierre",
      "comentari": "Comentario",
      "nota": "Nota",
      "motiu": "Motivo",
      "itcauRef": "Referencia ITCAU",
      "itcauUrl": "Enlace (opcional)",
      "missatgeFinal": "Mensaje de finalización",
      "mesuresPendents": "Medidas pendientes",
      "notificar": "Notificar el cierre a los destinatarios",
      "format": "Formato",
      "titol": "Título",
      "estat": "Estado",
      "confirmats": "Confirmados",
      "pendents": "Pendientes"
    },
    "accions": {
      "afegeixNota": "Añadir nota",
      "activaExpert": "Activar experto",
      "escalaAra": "Escalar ahora",
      "escala": "Escalar",
      "vinculaItcau": "Vincular ITCAU",
      "informe": "Informe",
      "tanca": "Cerrar la activación",
      "descarrega": "Descargar",
      "obre": "Abrir",
      "reenvia_one": "Reenviar a {{count}} pendiente",
      "reenvia_other": "Reenviar a {{count}} pendientes",
      "tancaCurt": "Cerrar",
      "confirma": "Confirmar la recepción",
      "accepta": "Aceptar la gestión",
      "afegeixDestinataris": "Añadir destinatarios",
      "afegeixN_one": "Añadir {{count}} persona",
      "afegeixN_other": "Añadir {{count}} personas",
      "mes": "Más acciones"
    },
    "modals": {
      "nota": "Añadir una nota",
      "escalar": "Escalar la activación",
      "itcau": "Vincular con ITCAU",
      "expert": "Activar el técnico experto",
      "tancar": "Cerrar la activación",
      "informe": "Informe de la activación",
      "destinataris": "Añadir destinatarios"
    },
    "escalarText": "Se avisará a los destinatarios del nivel {{nivell}} del circuito de escalado.",
    "escalarTria": "Elige a quién quieres escalar. Primero se muestran los técnicos expertos del servicio.",
    "escalarExperts": "Técnicos expertos",
    "escalarAltres": "Otras personas",
    "escalarCerca": "Busca una persona…",
    "escalarSenseCandidats": "No se ha encontrado ninguna persona.",
    "escalarA": "Escalar a {{nom}}",
    "escalarCircuit": "Escalar al siguiente nivel del circuito",
    "itcauText": "El vínculo es manual: no se sincroniza ningún campo con ITCAU.",
    "expertText": "Se avisará al técnico experto titular del servicio {{servei}} (o al sustituto si no está disponible).",
    "informeText": "Incluye destinatarios, canales, marcas de tiempo, confirmaciones, mensajes y acciones.",
    "missatgeFinalPlaceholder": "SITUACIÓN FINALIZADA. Se recupera la normalidad.",
    "reenviarText": "Reenvía el aviso a las personas pendientes desde aquí.",
    "reenviat_one": "Se ha reenviado {{count}} aviso.",
    "reenviat_other": "Se han reenviado {{count}} avisos.",
    "senseAccions": "Todavía no hay ninguna acción registrada.",
    "senseMissatges": "Todavía no hay mensajes.",
    "senseDestinataris": "No hay destinatarios.",
    "senseDocuments": "El servicio no tiene documentación publicada.",
    "escriuMissatge": "Escribe una actualización… (@ para mencionar)",
    "mencions": "Menciones",
    "tipusMencio": {
      "USUARI": "Persona",
      "SERVEI": "Servicio",
      "DEPARTAMENT": "Departamento"
    },
    "tipusMissatge": {
      "TEXT": "Mensaje",
      "RISC": "Riesgo",
      "AFECTACIO": "Afectación",
      "NOVETAT": "Novedad",
      "RECURSOS": "Recursos",
      "SISTEMA": "Sistema",
      "FINALITZACIO": "Finalización"
    },
    "accio": {
      "CREADA": "{{usuari}} ha creado la activación",
      "ENVIADA": "Aviso enviado a los destinatarios",
      "CONFIRMADA": "{{usuari}} ha confirmado la recepción",
      "ACCEPTADA": "{{usuari}} ha aceptado la activación",
      "REENVIADA": "{{usuari}} ha reenviado el aviso a los pendientes",
      "ESCALADA": "Escalado al siguiente nivel",
      "escaladaNivells": "Escalada del nivel {{origen}} al {{desti}}",
      "per": "por {{usuari}}",
      "automatic": "automáticamente",
      "EXPERT_ACTIVAT": "{{usuari}} ha activado el técnico experto",
      "NOTA": "{{usuari}} ha añadido una nota",
      "ITCAU_VINCULAT": "{{usuari}} ha vinculado la incidencia ITCAU",
      "TANCADA": "{{usuari}} ha cerrado la activación",
      "DOCUMENT_CONSULTAT": "{{usuari}} ha consultado un documento",
      "ALTRA": "Acción registrada por {{usuari}}"
    },
    "tipusDesti": {
      "TECNIC_GUARDIA_TITULAR": "Técnico de guardia titular",
      "TECNIC_GUARDIA_SUBSTITUT": "Técnico de guardia sustituto",
      "TECNIC_GUARDIA_DEPARTAMENT": "Técnico de guardia del departamento",
      "TECNIC_GUARDIA_ALTRES_AREES": "Técnicos de guardia de otras áreas",
      "EXPERT_TITULAR": "Técnico experto titular",
      "EXPERT_SUBSTITUT": "Técnico experto sustituto",
      "USUARI": "Persona",
      "GRUP": "Grupo",
      "ALTRE": "Destinatarios del nivel"
    },
    "estatNivell": {
      "fet": "Avisado",
      "actual": "Nivel actual",
      "pendent": "Pendiente"
    },
    "tu": "Tú",
    "haAcceptat": "ha aceptado la gestión",
    "deTotal": "{{valor}} de {{total}}",
    "nivellMinuts": "Nivel {{nivell}} · {{minuts}} min",
    "senseCircuit": "El servicio no tiene ningún circuito de escalado configurado.",
    "documentsNota": "Solo consulta para roles autorizados del servicio {{servei}}.",
    "propi": {
      "titol": "Eres destinatario de esta activación",
      "textConfirmar": "Confirma que la has recibido para que no se escale al nivel siguiente.",
      "textAcceptar": "Como técnico, puedes asumir su gestión."
    },
    "destinatarisText": "Las personas añadidas reciben el aviso por los canales de la activación y entran en el bloque de destinatarios adicionales.",
    "cercaPersona": "Busca por nombre o correo…",
    "treu": "Quitar {{nom}}",
    "senseResultats": "Ninguna persona coincide con la búsqueda.",
    "expertTria": "Técnico experto a activar",
    "expertAutomatic": "Automático",
    "expertAutomaticText": "El titular disponible o, si no, el sustituto",
    "rolExpert": {
      "TITULAR": "Titular",
      "SUBSTITUT": "Sustituto"
    },
    "accioTitol": {
      "CREADA": "Activación creada",
      "ENVIADA": "Notificación enviada",
      "CONFIRMADA": "Confirmación",
      "ACCEPTADA": "Gestión aceptada",
      "REENVIADA": "Aviso reenviado",
      "ESCALADA": "Escalado",
      "EXPERT_ACTIVAT": "Experto activado",
      "NOTA": "Nota",
      "ITCAU_VINCULAT": "Vinculada a ITCAU",
      "TANCADA": "Activación cerrada",
      "DOCUMENT_CONSULTAT": "Documento consultado",
      "ALTRA": "Acción"
    },
    "obertaPer": "abierta {{hora}} por {{persona}}",
    "itcauRef": "ITCAU {{ref}}",
    "itcauSense": "ITCAU sin vincular",
    "senseActivitat": "Todavía no hay actividad registrada.",
    "pestanyes": {
      "etiqueta": "Secciones del detalle",
      "activitat": "Actividad",
      "xat": "Chat · {{count}}",
      "persones": "Personas · {{count}}",
      "dades": "Datos",
      "documents": "Documentos · {{count}}"
    },
    "franja": {
      "confirmats": "Confirmados",
      "haConfirmat": "confirmó a las {{hora}}",
      "escalat": "Escalado",
      "nivellSeguent": "Nivel {{actual}} → nivel {{seguent}} ({{desti}})",
      "enMinuts": "en {{minuts}} min",
      "imminent": "inminente",
      "senseEscalat": "Todos han confirmado: no se escalará.",
      "tancada": "Activación cerrada."
    },
    "ajudaComposer": "Intro para enviar · Mayús+Intro para una línea nueva",
    "peuImatge": "Añade un pie a la imagen (opcional)…",
    "format": {
      "barra": "Formato del texto",
      "negreta": "Negrita (Ctrl+B)",
      "cursiva": "Cursiva (Ctrl+I)",
      "ratllat": "Tachado",
      "llista": "Lista con viñetas",
      "llistaNumerada": "Lista numerada",
      "codi": "Código"
    },
    "imatge": {
      "adjunta": "Adjuntar una imagen",
      "treu": "Quitar la imagen",
      "tipusNoPermes": "Solo se pueden adjuntar imágenes JPEG, PNG o WebP.",
      "massaGran": "La imagen supera el límite de 10 MB.",
      "alt": "Imagen enviada por {{autor}}",
      "obre": "Abrir la imagen",
      "visor": "Imagen del chat",
      "errorCarrega": "No se ha podido cargar la imagen",
      "carregant": "Cargando la imagen…",
      "deixaAnar": "Suelta la imagen para adjuntarla"
    },
    "xat": {
      "conversa": "Conversación de la activación",
      "buit": "Todavía no hay mensajes en el chat.",
      "nomesLectura": "La activación está cerrada: el chat es de solo lectura."
    },
    "silenci": {
      "silenciar": "Silenciar",
      "reactivar": "Reactivar notificaciones",
      "explicacioSilenciar": "Silencia solo las notificaciones de los mensajes del chat de esta activación. Las alertas, confirmaciones y escalados se siguen recibiendo.",
      "explicacioReactivar": "Los mensajes del chat de esta activación están silenciados. Las alertas, confirmaciones y escalados se siguen recibiendo."
    }
  },
  "assistent": {
    "subtitol": "Mismo flujo para Guardia y Crisis",
    "pas": "Paso {{n}}",
    "passos": {
      "servei": "Servicio",
      "tipus": "Tipo",
      "dades": "Datos",
      "destinataris": "Destinatarios",
      "revisio": "Revisión"
    },
    "titols": {
      "servei": "¿Qué servicio está afectado?",
      "tipus": "Tipo de activación",
      "dades": "Datos de la activación",
      "destinataris": "¿A quién hay que avisar?",
      "revisio": "Revisa y envía"
    },
    "serveiText": "Busca en todas las áreas permitidas. Si no encuentras el servicio, elige el departamento (solo Guardia).",
    "cercaServei": "Busca un servicio, área o departamento",
    "senseServeis": "Ningún resultado.",
    "departamentSencer": "Departamento",
    "tipusText": {
      "AVIS": "Comunicación informativa o preventiva.",
      "INCIDENCIA": "Requiere actuación del técnico de guardia o del grupo."
    },
    "tipusAvis": "Tipo de aviso",
    "tipusAvisDefecte": "Por defecto",
    "marcaCritica": "Crítica",
    "senseCritica": "No tienes permiso para crear activaciones críticas.",
    "avisCritica": "Se enviará como alerta crítica: suena aunque el dispositivo esté en silencio.",
    "camps": {
      "titol": "Título",
      "descripcio": "Descripción",
      "proves": "Pruebas realizadas",
      "inici": "Fecha y hora de inicio",
      "zona": "Zona",
      "ubicacio": "Ubicación",
      "contacte": "Persona de contacto",
      "risc": "Riesgo",
      "perills": "Peligros identificados",
      "mesures": "Medidas de actuación",
      "missatge": "Mensaje"
    },
    "senseZona": "Sin zona",
    "plantillaText": "Este servicio tiene una plantilla de mensaje: completa zona, riesgo, peligros y medidas.",
    "opcional": "(opcional en crisis)",
    "persones_one": "{{count}} persona",
    "persones_other": "{{count}} personas",
    "cercaPersona": "Añadir personas (buscar por nombre)",
    "afegeix": "+ {{nom}}",
    "treu": "{{nom}} ✕",
    "canals": "Canales de envío",
    "envia": "Enviar la activación",
    "enviaCritica": "Enviar la alerta crítica",
    "enviaIgualment": "Enviar igualmente",
    "criticaPermis": "Requiere permiso de activación crítica",
    "sensePlantillaText": "Este servicio no tiene plantilla: solo campos comunes.",
    "esNotificara_one": "Se notificará a {{count}} persona",
    "esNotificara_other": "Se notificará a {{count}} personas",
    "continuaRevisio": "Continuar a la revisión",
    "pasNom": "{{n}} · {{nom}}"
  },
  "seguiment": {
    "obertes_one": "{{count}} activación abierta",
    "obertes_other": "{{count}} activaciones abiertas",
    "llista": "Activaciones en seguimiento",
    "obreDetall": "Abrir el detalle",
    "lliurats": "Entregados",
    "llegits": "Leídos",
    "confirmats": "Confirmados",
    "pendents": "Pendientes",
    "zones": "Zonas afectadas",
    "senseZones": "Sin zona indicada.",
    "senseConfirmar": "sin confirmar",
    "totsConfirmats": "todos han confirmado"
  },
  "temps": {
    "min": "hace {{min}} min",
    "hMin": "hace {{h}} h {{min}} min",
    "dies_one": "hace {{count}} día",
    "dies_other": "hace {{count}} días"
  },
  "centre": {
    "subtitol": "{{data}} · {{hora}} · se actualiza en directo",
    "cerca": "Buscar activación, persona o servicio",
    "cercaEtiqueta": "Buscar activaciones",
    "araMateix": "Ahora mismo",
    "kpi": {
      "obertes": "Activaciones abiertas",
      "critiques_one": "{{count}} crítica",
      "critiques_other": "{{count}} críticas",
      "crisi_one": "{{count}} crisis",
      "crisi_other": "{{count}} crisis",
      "confirmacions": "Confirmaciones recibidas",
      "confirmacionsDetall": "{{confirmats}} de {{total}} personas",
      "cobertura": "Cobertura de guardia",
      "buits_one": "{{count}} hueco",
      "buits_other": "{{count}} huecos",
      "totCobert": "Todo cubierto"
    },
    "enCurs": "En curso",
    "perUrgencia": "ordenadas por urgencia",
    "confirmats": "Confirmados",
    "totsConfirmats": "Todos han confirmado",
    "escalada": "Escalada · nivel {{nivell}}",
    "informatiu": "Informativo",
    "pendents_one": "{{count}} pendiente",
    "pendents_other": "{{count}} pendientes",
    "deGuardiaNom": "{{nom}} de guardia",
    "atencio": "Necesita tu atención",
    "totEnOrdre": "Todo en orden: no hay huecos de guardia ni solicitudes pendientes.",
    "buit": "Hueco",
    "buitText": "{{area}} no tiene técnico de guardia ahora mismo.",
    "assignaGuardia": "Asignar guardia",
    "sollicitudsText_one": "{{count}} solicitud de cambio de turno espera tu aprobación.",
    "sollicitudsText_other": "{{count}} solicitudes de cambio de turno esperan tu aprobación.",
    "revisa": "Revisar",
    "deGuardia": "De guardia ahora",
    "calendari": "Calendario",
    "truca": "Llamar a {{nom}}",
    "mostraTotes_one": "Ver el área",
    "mostraTotes_other": "Ver las {{count}} áreas",
    "mostraMenys": "Ver menos"
  },
  "nova": {
    "subtitol": "Un solo formulario para Guardia y Crisis. Los destinatarios se proponen a partir del servicio.",
    "blocs": {
      "que": "¿Qué está pasando?",
      "qui": "¿A quién avisamos?",
      "revisa": "Revisa y envía"
    },
    "servei": "Servicio afectado",
    "canviaServei": "Cambiar",
    "tipusText": {
      "AVIS": "Informa; no hace falta actuar.",
      "INCIDENCIA": "El técnico de guardia tiene que actuar."
    },
    "marcaCritica": "Marcar como crítica: suena aunque el móvil esté en silencio",
    "descripcio": "Qué ves y qué has probado",
    "detalls": "Más detalles (inicio, zona, contacto)",
    "detallsPlantilla": "+ Zona, riesgo y medidas (plantilla del servicio)",
    "amagaDetalls": "Ocultar los detalles",
    "proposat": "Propuesto por el circuito de {{servei}}",
    "triaServeiPrimer": "Elige el servicio afectado para ver a quién se avisará.",
    "afegidaMa": "Añadida a mano",
    "treu": "Quitar",
    "afegeixAlgu": "Añadir a alguien más",
    "savisaA": "Se avisa a",
    "senseTitol": "Sin título",
    "falta": {
      "etiqueta": "Falta por completar",
      "servei": "Elige el servicio afectado",
      "titol": "Escribe un título",
      "destinataris": "Activa al menos un grupo de destinatarios",
      "canals": "Elige al menos un canal"
    },
    "circuitText": "A quién se avisa y por qué canal lo decide la configuración del servicio y su circuito de escalado: primero el técnico de guardia (del área o, si no hay, del departamento) y los usuarios a informar; si no responde, llamada, push crítico y escalado al siguiente técnico y a los expertos."
  }
}
